interface ReportMetric {
    id: string;
    name: string;
    value: number;
    delta: number;
    rating: string;
    entries: PerformanceEntry[];
    navigationType: string;
}

const reportWebVitals = (onPerfEntry?: (metric: ReportMetric) => void) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        import('web-vitals').then(({onCLS, onINP, onFCP, onLCP, onTTFB}) => {
            onCLS(onPerfEntry);
            onINP(onPerfEntry);
            onFCP(onPerfEntry);
            onLCP(onPerfEntry);
            onTTFB(onPerfEntry);
        });
    }
};

export default reportWebVitals;
